export default "__VITE_ASSET__DZPg6F35__"